module.exports = __webpack_public_path__ + "static/media/cert_65.4f9c4cfe.jpg";